/* ============================================
   絞り込みUI a11y 補完
   2026-07-26 — proposals/06-filter-redesign ステップ1

   tcg-collection.js は既に以下を持っている:
     - サイドバー開閉 (.is-open) と body scroll lock
     - 外側クリックで閉じる / Escapeで閉じる
     - セクション見出しクリックで body に .is-open をトグル
   ここでは重複させず、欠けている分だけを足す:
     1. セクション見出しの aria-expanded を実状態に同期
     2. ドロワーを閉じたときトリガーにフォーカスを戻す
     3. 開いたときドロワー内へフォーカスを移す

   2026-07-26 絞り込みUI改修 (仕様書 A-3/A-4/B/D/E) で追加:
     4. rarity フォームへの透過パラメータ注入 (per_page / size / 未知パラメータ)
     5. 適用ボタンの件数プレビュー (section_id レンダリングを先読み)
     6. クイックチップ (高レア / 金額しきい値) の checkbox・hidden 操作
     7. モバイルシートの inert / フォーカストラップ
   ============================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var sidebar = document.getElementById('tcg-sidebar');
    if (!sidebar) return;

    /* --- 1. aria-expanded の同期 --- */
    var headers = document.querySelectorAll('[data-tcg-sidebar-toggle]');

    function syncHeader(header) {
      var body = header.nextElementSibling;
      if (!body) return;
      header.setAttribute('aria-expanded', body.classList.contains('is-open') ? 'true' : 'false');
    }

    headers.forEach(function (header) {
      syncHeader(header);
      var body = header.nextElementSibling;
      if (!body) return;
      // .is-open を書き換えるのは tcg-collection.js 側なので、
      // クリックを横取りせず class の変化そのものを監視する。
      // (requestAnimationFrame はタブが非表示だと発火せず同期が漏れる)
      new MutationObserver(function () {
        syncHeader(header);
      }).observe(body, { attributes: true, attributeFilter: ['class'] });
    });

    /* --- 2 / 3. ドロワーのフォーカス管理 --- */
    var toggleBtn = document.getElementById('tcg-filter-toggle');
    var closeBtn = document.getElementById('tcg-sidebar-close');
    var wasOpen = sidebar.classList.contains('is-open');

    if (toggleBtn) toggleBtn.setAttribute('aria-controls', 'tcg-sidebar');

    /* --- 7. モバイルシートの inert / フォーカストラップ (仕様書 D) --- */
    // シートは閉時も DOM に残る。デスクトップは常時表示なので、モバイル幅のときだけ塞ぐ。
    var sheetMedia = window.matchMedia('(max-width: 768px)');
    var supportsInert = 'inert' in HTMLElement.prototype;

    function applyInert(isOpen) {
      var shouldBlock = sheetMedia.matches && !isOpen;
      if (supportsInert) {
        sidebar.inert = shouldBlock;
        return;
      }
      // 非対応ブラウザは支援技術からだけでも隠す (Tab は素通りするが実害は小さい)
      if (shouldBlock) sidebar.setAttribute('aria-hidden', 'true');
      else sidebar.removeAttribute('aria-hidden');
    }

    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]),' +
      ' select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function focusableItems() {
      return Array.prototype.filter.call(sidebar.querySelectorAll(FOCUSABLE), function (el) {
        // 視覚的に隠した rarity checkbox は 1px あるので残る。display:none の要素だけ落とす
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (!sidebar.classList.contains('is-open')) return;
      var items = focusableItems();
      if (items.length === 0) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (items.indexOf(document.activeElement) === -1) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    function onOpenStateChange(isOpen) {
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      applyInert(isOpen);
      if (isOpen) {
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      } else if (wasOpen && toggleBtn && typeof toggleBtn.focus === 'function') {
        // 閉じた直後だけ戻す (初期描画では動かさない)
        toggleBtn.focus();
      }
      wasOpen = isOpen;
    }

    onOpenStateChange(wasOpen);

    // 幅が変わると inert の要否が変わる (デスクトップに戻ったら必ず解除する)
    if (typeof sheetMedia.addEventListener === 'function') {
      sheetMedia.addEventListener('change', function () {
        applyInert(sidebar.classList.contains('is-open'));
      });
    } else if (typeof sheetMedia.addListener === 'function') {
      sheetMedia.addListener(function () {
        applyInert(sidebar.classList.contains('is-open'));
      });
    }

    // .is-open は複数箇所から付け外しされるので、属性監視でまとめて拾う
    new MutationObserver(function () {
      var isOpen = sidebar.classList.contains('is-open');
      if (isOpen !== wasOpen) onOpenStateChange(isOpen);
    }).observe(sidebar, { attributes: true, attributeFilter: ['class'] });

    /* --- 4〜6. rarity フォーム (透過パラメータ / 件数プレビュー / クイックチップ) --- */
    var form = document.getElementById('tcg-filter-form');
    if (form) {
      injectPassthroughParams(form);
      initCountPreview(form);
      initQuickChips(form);
    }
  });

  /* ============================================
     4. 透過パラメータの hidden 注入 (仕様書 A-3)
     per_page / size は JS 管理のUIで、view 等の未知パラメータも含めて Liquid 側からは
     出せない (request.params が空を返すため)。現在のURLから拾って hidden に写す。
     page は必ず落とす — 絞り込み直後に存在しないページ番号へ飛ぶのを防ぐ。
     Liquid が既に出している名前 (sort_by / filter.v.*) は二重送信になるので触らない。
     ============================================ */
  function injectPassthroughParams(form) {
    var existing = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name) existing[el.name] = true;
    });

    var params = new URLSearchParams(window.location.search);
    var keys = [];
    params.forEach(function (_value, key) {
      if (keys.indexOf(key) === -1) keys.push(key);
    });

    keys.forEach(function (key) {
      if (key === 'page' || key === 'section_id' || key === 'filter.p.tag') return;
      if (existing[key]) return;
      params.getAll(key).forEach(function (value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        input.setAttribute('data-tcg-passthrough', '');
        form.appendChild(input);
      });
    });
  }

  /* ============================================
     5. 件数プレビュー (仕様書 B)
     change のたびに同じセクションを section_id レンダリングで取り、
     data-products-total を読んで適用ボタンの文言に反映する。
     - change で即 abort → 300ms debounce (連打でリクエストを積まない)
     - 世代トークンで最新のレスポンスだけを反映 (古い件数が残らない)
     - 失敗しても文言を戻すだけで submit は阻害しない
     - parse は正規表現 (DOMParser は数十KBのHTMLに対して割に合わない)
     ============================================ */
  function initCountPreview(form) {
    var button = document.querySelector('[data-tcg-filter-apply]');
    if (!button || typeof window.fetch !== 'function') return;

    var sectionId = form.getAttribute('data-tcg-section-id');
    if (!sectionId) return;

    var FALLBACK_LABEL = 'View results';
    var timer = null;
    var controller = null;
    var generation = 0;

    function request() {
      var myGeneration = ++generation;
      controller = 'AbortController' in window ? new AbortController() : null;

      var params = new URLSearchParams(new FormData(form));
      params.delete('page');
      params.append('section_id', sectionId);

      // action を持つのは legacy 正規化のときだけ。無いときは現在のパス (タグURLを維持)
      var path = form.getAttribute('action') || window.location.pathname;

      fetch(path + '?' + params.toString(), controller ? { signal: controller.signal } : undefined)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          if (myGeneration !== generation) return;
          var matched = html.match(/data-products-total="(\d+)"/);
          if (!matched) throw new Error('total not found');
          // Shopify のページネーション件数は 25,000 超で番兵値 25001 を返す (Liquid側の表示と揃える)
          var total = parseInt(matched[1], 10);
          button.textContent = 'View ' + (total >= 25001 ? '25,000+' : matched[1]) + ' results';
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return; // 後続の変更で上書きされただけ
          if (myGeneration !== generation) return;
          button.textContent = FALLBACK_LABEL;
        });
    }

    form.addEventListener('change', function () {
      if (controller) {
        controller.abort();
        controller = null;
      }
      clearTimeout(timer);
      button.textContent = 'Updating…';
      timer = setTimeout(request, 300);
    });
  }

  /* ============================================
     6. クイックチップ (仕様書 E)
     Shopify は「複数値をまとめて add する URL」を出さないので、URLを手組みせず
     フォームの checkbox / hidden を書き換えて submit する。
     Liquid 側は hidden 属性付きで描画しているので、ここで表に出す (JSオフでは非表示)。
     ============================================ */
  function initQuickChips(form) {
    var chips = document.querySelectorAll('[data-tcg-chip]');
    if (chips.length === 0) return;

    Array.prototype.forEach.call(chips, function (chip) {
      chip.removeAttribute('hidden');

      chip.addEventListener('click', function () {
        var turnOn = !chip.classList.contains('is-active');
        var kind = chip.getAttribute('data-tcg-chip');

        if (kind === 'high-rarity') {
          // 対象の3種だけを on/off する。他に選択済みの rarity は残す
          var targets = (chip.getAttribute('data-tcg-chip-values') || '').split(',');
          var boxes = form.querySelectorAll('input[name="filter.p.tag"]');
          Array.prototype.forEach.call(boxes, function (box) {
            if (box.disabled) return;
            if (targets.indexOf(box.value) === -1) return;
            box.checked = turnOn;
          });
        } else if (kind === 'price-lte') {
          var lte = form.querySelector('input[name="filter.v.price.lte"]');
          if (turnOn) {
            if (!lte) {
              lte = document.createElement('input');
              lte.type = 'hidden';
              lte.name = 'filter.v.price.lte';
              form.appendChild(lte);
            }
            lte.value = chip.getAttribute('data-tcg-chip-value') || '10';
          } else if (lte) {
            lte.parentNode.removeChild(lte);
          }
        } else {
          return;
        }

        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });
  }
})();
